// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2U1A2","right":"styles_right__13_CR"};